export const GET_NAV_PLANS_BASE = 'PLANS_GET_NAV';
export const GET_NAV_PLANS_START = `${GET_NAV_PLANS_BASE}_START`;
export const GET_NAV_PLANS_SUCCESS = `${GET_NAV_PLANS_BASE}_SUCCESS`;
export const GET_NAV_PLANS_FAIL = `${GET_NAV_PLANS_BASE}_FAIL`;

export const GET_NAV_FORMS_BY_PLAN = 'GET_NAV_FORMS_BY_PLAN';
export const GET_NAV_FORMS_BY_PLAN_START = `${GET_NAV_FORMS_BY_PLAN}_START`;
export const UPDATE_NAV_PLANS_AND_FORMS = 'UPDATE_NAV_PLANS_AND_FORMS';

export function getNav() {
  return {
    type: GET_NAV_PLANS_BASE,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/plans?planType=plan&sortBy=userDefined&embed=forms,forms.recipients',
      method: 'get',
    },
  };
}

export function getNavFormsByPlanId(planId) {
  return {
    type: GET_NAV_FORMS_BY_PLAN,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${planId}/forms?embed=recipients`,
      method: 'get',
    },
    payload: {
      planId,
    },
  };
}

export function updateNav(plans) {
  return dispatch => {
    const promises = plans
      .filter(({ forms }) => forms && forms.count < forms.total)
      .map(({ id }) => dispatch(getNavFormsByPlanId(id)));

    return Promise.all(promises).then(aggregatedData =>
      dispatch({
        type: UPDATE_NAV_PLANS_AND_FORMS,
        payload: aggregatedData,
      }),
    );
  };
}
